import { LeaveGuardModal } from '@shared/components/Modal/LeaveGuardModal/LeaveGuardModal';
import { useLeaveGuardModalContext } from '@shared/providers/LeaveGuardModalProvider/useLeaveGuardModalContext.ts';

export function LeaveGuardModalSocket() {
  const { modalConfig } = useLeaveGuardModalContext();

  if (!modalConfig) {
    return null;
  }

  return (
    <LeaveGuardModal
      cancelCallback={modalConfig.onCancel}
      submitCallback={modalConfig.onSubmit}
      headerText={modalConfig.headerText}
      cancelLabelText={modalConfig.cancelLabelText}
      submitLabelText={modalConfig.submitLabelText}
      submitIsLoading={modalConfig.submitIsLoading}
    >
      {modalConfig.body}
    </LeaveGuardModal>
  );
}
